import { TrackingClient } from '@sparefoot/tracking-client';

export const trackCTAClick = (clickId, clickName, clickText, clickUrl) => {
	const trackingProps = { clickId, clickName, clickText, clickUrl };
	if (typeof window !== 'undefined') {
		TrackingClient.trackCTAClick(trackingProps);
	}
};

export const trackContactLinkClick = (
	clickId,
	clickName,
	clickText,
	contactType,
) => {
	const trackingProps = {
		clickId,
		clickName,
		clickText,
		contactType,
	};
	if (typeof window !== 'undefined') {
		TrackingClient.trackContactLinkClicked(trackingProps);
	}
};

export const trackOutboundLinkClick = (
	clickId,
	clickName,
	clickText,
	clickUrl,
) => {
	const trackingProps = {
		clickId,
		clickName,
		clickText,
		clickUrl,
	};

	if (typeof window !== 'undefined') {
		TrackingClient.trackOutboundLinkClicked(trackingProps);
	}
};
